module.exports = __webpack_public_path__ + "../resources/img/ic_dropdown_arrow_down.914824c8.svg";